/*
  TBL Global JS
  IntersectionObserver to trigger fade-in scroll animations.
  Watches all elements with .tbl-animate class and adds
  .tbl-animate--visible when they enter the viewport.
  Last updated: 8 May 2026
*/

(function () {
  'use strict';

  function initAnimations() {
    var elements = document.querySelectorAll('.tbl-animate');
    if (!elements.length) return;

    // If browser doesn't support IntersectionObserver, just show everything
    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (el) {
        el.classList.add('tbl-animate--visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('tbl-animate--visible');
            // Unobserve after firing — animation plays once only
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -40px 0px'
      }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnimations);
  } else {
    initAnimations();
  }
})();
